// material-ui
import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - AUTOCOMPLETE ||============================== //

export default function Autocomplete(theme: Theme) {
  const { mode } = theme.palette;
  const isClassic = mode === 'dark' && theme.palette.background.default === '#000000';

  return {
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          ...(isClassic && {
            '& .MuiOutlinedInput-root': {
              backgroundColor: '#2d2d2d',
              '& fieldset': {
                borderColor: '#404040',
              },
              '&:hover fieldset': {
                borderColor: '#525252',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#FFD700',
              },
              '& input': {
                color: '#FFD700',
                '&::placeholder': {
                  color: '#808080',
                  opacity: 1,
                },
              },
            },
            '& .MuiInputLabel-root': {
              color: '#FFD700', // Gold color for Classic theme
              '&.Mui-focused': {
                color: '#FFD700', // Gold color when focused
              },
            },
            '& .MuiFormHelperText-root': {
              color: '#cccccc',
            },
          }),
          '& .MuiOutlinedInput-root': {
            padding: '8px 12px', // Standard padding for uniform height
            minHeight: '40px', // Ensure consistent height
            '& .MuiAutocomplete-input': {
              padding: '0 !important', // Remove default padding to use parent padding
              fontSize: '1.1rem' // Increased from 1rem to 1.1rem for larger text
            }
          },
          '& .MuiAutocomplete-inputRoot': {
            padding: '8px 12px', // Standard padding for uniform height
            minHeight: '40px', // Ensure consistent height
            '& .MuiAutocomplete-input': {
              padding: '0 !important', // Remove default padding to use parent padding
              fontSize: '1.1rem' // Increased from 1rem to 1.1rem for larger text
            }
          },
          '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
            padding: '8px 12px', // Standard padding for uniform height
            minHeight: '40px', // Ensure consistent height
            '& .MuiAutocomplete-input': {
              padding: '0 !important', // Remove default padding to use parent padding
              fontSize: '1.1rem' // Increased from 1rem to 1.1rem for larger text
            }
          },
          '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
            padding: '0 !important', // Remove default padding to use parent padding
            fontSize: '1.1rem' // Increased from 1rem to 1.1rem for larger text
          },
          '& .MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"]': {
            padding: '8px 12px', // Standard padding for uniform height
            minHeight: '40px', // Ensure consistent height
            '& .MuiAutocomplete-input': {
              padding: '0 !important', // Remove default padding to use parent padding
              fontSize: '1.1rem' // Increased from 1rem to 1.1rem for larger text
            }
          },
          '& .MuiAutocomplete-inputRoot[class*="MuiFilledInput-root"] .MuiAutocomplete-input': {
            padding: '0 !important', // Remove default padding to use parent padding
            fontSize: '1.1rem' // Increased from 1rem to 1.1rem for larger text
          },
          '& .MuiAutocomplete-inputRoot[class*="MuiInputBase-root"]': {
            padding: '8px 12px', // Standard padding for uniform height
            minHeight: '40px', // Ensure consistent height
            '& .MuiAutocomplete-input': {
              padding: '0 !important', // Remove default padding to use parent padding
              fontSize: '1.1rem' // Increased from 1rem to 1.1rem for larger text
            }
          },
          '& .MuiAutocomplete-inputRoot[class*="MuiInputBase-root"] .MuiAutocomplete-input': {
            padding: '0 !important', // Remove default padding to use parent padding
            fontSize: '1.1rem' // Increased from 1rem to 1.1rem for larger text
          }
        },
        paper: {
          ...(isClassic && {
            backgroundColor: '#1a1a1a',
            '& .MuiAutocomplete-listbox': {
              backgroundColor: '#1a1a1a',
              '& .MuiAutocomplete-option': {
                color: '#FFD700',
                '&[aria-selected="true"]': {
                  backgroundColor: '#2d2d2d',
                },
                '&[data-focus="true"]': {
                  backgroundColor: '#2d2d2d',
                },
                '&:hover': {
                  backgroundColor: '#2d2d2d',
                },
              },
            },
          }),
          '& .MuiAutocomplete-listbox': {
            '& .MuiAutocomplete-option': {
              '&[aria-selected="true"]': {
                backgroundColor: 'primary.lighter'
              },
              '&[data-focus="true"]': {
                backgroundColor: 'primary.lighter'
              }
            }
          }
        }
      }
    }
  };
}
